import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ApiError, centsToUSD, finance as financeApi, type Receipt as ReceiptT } from '../api';

export function Receipt() {
  const { unitId = '', paymentId = '' } = useParams();
  const [r, setR] = useState<ReceiptT | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    financeApi
      .payments
      .receipt(unitId, paymentId)
      .then(setR)
      .catch((e) => setError(e instanceof ApiError ? e.message : 'Receipt not found'));
  }, [unitId, paymentId]);

  if (error) return <div className="panel"><p className="error">{error}</p></div>;
  if (!r) return <p className="muted">Loading…</p>;

  return (
    <div className="panel receipt-page">
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'baseline' }}>
        <h1>Payment receipt</h1>
        <button className="no-print" onClick={() => window.print()}>
          Print / save PDF
        </button>
      </div>
      <p className="muted">{r.unitName}</p>
      {r.reversed && <p className="error">This payment has been reversed.</p>}
      <table className="grid">
        <tbody>
          <tr>
            <td>Receipt #</td>
            <td>{r.receiptId}</td>
          </tr>
          <tr>
            <td>Scout</td>
            <td>{r.scoutName}</td>
          </tr>
          <tr>
            <td>Amount</td>
            <td>
              <strong>{centsToUSD(r.amountCents)}</strong>
            </td>
          </tr>
          <tr>
            <td>Method</td>
            <td>{r.method}</td>
          </tr>
          <tr>
            <td>Paid on</td>
            <td>{r.paidAt}</td>
          </tr>
          {r.reference && (
            <tr>
              <td>Reference</td>
              <td>{r.reference}</td>
            </tr>
          )}
          {r.note && (
            <tr>
              <td>Note</td>
              <td>{r.note}</td>
            </tr>
          )}
          <tr>
            <td>Issued</td>
            <td>{new Date(r.issuedAt).toLocaleString()}</td>
          </tr>
        </tbody>
      </table>
      <p className="muted small">
        DenLodge is not affiliated with Scouting America. Keep this receipt for your records.
      </p>
    </div>
  );
}
